import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  isFeedScrolling: false,
  areNotificationsScrolling: false,
  isRefreshFeed: false,
  feedScrollPosition: 0,
  topHeader: true,
  showHeader : true
};

export const NavigationSlice = createSlice({
  name: "navigation_slice",
  initialState,
  reducers: {
    feedScrollToTop: (state, action: PayloadAction<boolean>) => {
      state.isFeedScrolling = action.payload;
      return state;
    },
    notificationsScrollToTop: (state, action: PayloadAction<boolean>) => {
      state.areNotificationsScrolling = action.payload;
      return state;
    },
    refreshFeed: (state, action: PayloadAction<boolean>) => {
      state.isRefreshFeed = action.payload;
      state.showHeader = true;
      return state;
    },
    setFeedScrollPosition: (state, action: PayloadAction<number>) => {
      state.feedScrollPosition = action.payload;
      return state;
    },
    setTopHeader: (state, action: PayloadAction<boolean>) => {
      state.topHeader = action.payload;
      return state;
    },
    setShowHeader: (state, action: PayloadAction<boolean>) => {
      state.showHeader = action.payload;
      return state;
    },
  },
});

export const { feedScrollToTop, notificationsScrollToTop, refreshFeed, setFeedScrollPosition, setTopHeader , setShowHeader } =
  NavigationSlice.actions;
export default NavigationSlice.reducer;
